import React, { useContext, useEffect } from "react";

import moment from "moment";
import Select from "react-select";

import CustomCalendar from "../../CustomCalender/index";
import { useRef } from "react";
import ExportButton from "../Export/Export";
import { checkModuleGeneralPermission } from "../../../helpers/helpers";
import { AppContext } from "../../../context/AppContext";
import useStorage from "../../../helpers/useStorage";
import ClearButton from "../ClearButton/ClearButton";
import {
  defaultSelectOption,
  defaultFromDateFilterValue,
  defaultToDateFilterValue,
  formatValueWithDefaultOption,
  getFilterDateRange,
} from "../../../helpers/utils";
import { reportDateFormat } from "../../../constants";
import CustomSelectClearIndicator from "../CustomSelectClearIndicator/CustomSelectClearIndicator";
const AcsReportFilter = ({
  filterDateRange,
  onSearchInputChange,
  oncrossTimeFromChange,
  onEventTypeChange,
  handleUpdateKey,
  exportData,
  buttonVisibility,
  oncrossTimeToChange,
  setResetPagination,
  onResetInitiated,
  tab,
  loading,
}) => {
  const { setToStorage, getFromStorage, removeFromStorage } = useStorage();
  const { userRoleDetails } = useContext(AppContext);
  const userTimezone = localStorage.getItem("userTz");

  const [searchText, setSearchText] = React.useState(
    getFromStorage("lpr_report_filter_search") ?? ""
  );
  const [crossTimeFrom, setcrossTimeFrom] = React.useState(null);

  const [crossTimeTo, setcrossTimeTo] = React.useState(null);

  const [minDate, setMinDate] = React.useState(null);
  const [maxDate, setMaxDate] = React.useState(null);

  const [eventType, setEventType] = React.useState(
    getFromStorage("lpr_report_filter_event_type") ?? defaultSelectOption()
  );

  const crossTimeFromRef = useRef(null);
  const crossTimeToRef = useRef(null);

  React.useEffect(() => {
    if (!searchText) {
      onSearchInputChange("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const [dateRange, setDateRange] = React.useState(null);

  React.useEffect(() => {
    if (!filterDateRange?.retentionValue) return;

    const resetFilters = () => {
      const maxMinDateRange = getFilterDateRange(
        filterDateRange?.retentionValue,
        filterDateRange?.retentionUnit,
        reportDateFormat,
        tab === "old" ? true : false
      );
      setMinDate(maxMinDateRange?.from);
      setMaxDate(maxMinDateRange?.to);

      let newDateRange;
      if (tab === "old") {
        newDateRange = getFilterDateRange(
          filterDateRange?.retentionValue,
          filterDateRange?.retentionUnit,
          reportDateFormat,
          true
        );
      } else {
        newDateRange = getFilterDateRange(
          filterDateRange?.defaultDurationValue,
          filterDateRange?.defaultDurationUnit
        );
      }

      setDateRange(newDateRange);
      setcrossTimeFrom(newDateRange?.from);
      setcrossTimeTo(newDateRange?.to);

      setSearchText("");
      setEventType(defaultSelectOption());

      if (onSearchInputChange) onSearchInputChange("");
      if (onEventTypeChange) onEventTypeChange("");

      if (crossTimeFromRef.current) {
        crossTimeFromRef.current.handleChange(newDateRange?.from);
      }
      if (crossTimeToRef.current) {
        crossTimeToRef.current.handleChange(newDateRange?.to);
      }
    };

    resetFilters();
  }, [tab, filterDateRange]);

  const eventTypeOptions = [
    defaultSelectOption(),
    { label: "Enter", value: 1 },
    { label: "Exit", value: 0 },
  ];

  const onFilterChange = (option) => {
    const { name, value, label } = option;
    switch (name) {
      case "cross_time_to":
        setcrossTimeTo(
          value === null ? "" : moment(value).format(reportDateFormat)
        );
        crossTimeToRef.current.handleChange(
          moment(value).format(reportDateFormat)
        );

        break;
      case "cross_time_from":
        setcrossTimeFrom(
          value === null ? "" : moment(value).format(reportDateFormat)
        );
        crossTimeFromRef.current.handleChange(
          moment(value).format(reportDateFormat)
        );

        break;
      case "type":
        setEventType({ label, value });
        break;
      default:
        break;
    }
  };

  const applyFilters = () => {
    oncrossTimeToChange(crossTimeTo);
    oncrossTimeFromChange(crossTimeFrom);
    setResetPagination(true);
    onEventTypeChange(eventType?.value);
    handleUpdateKey();
    onSearchInputChange(searchText);

    setToStorage(
      {
        lpr_report_filter_from_date: crossTimeFrom,
        lpr_report_filter_to_date: crossTimeTo,
        lpr_report_filter_search: searchText,
        lpr_report_filter_event_type: eventType,
      },
      false
    );
  };

  const handleSingleFieldReset = (field) => {
    switch (field) {
      case "search":
        setSearchText("");
        return;
      case "fromTime":
        setcrossTimeFrom("");
        crossTimeFromRef.current.handleChange("");
        return;
      case "toTime":
        setcrossTimeTo("");
        crossTimeToRef.current.handleChange("");
        return;
      default:
        return;
    }
  };

  const resetFilterOptions = () => {
    setcrossTimeFrom(dateRange?.from);
    crossTimeFromRef.current.handleChange(dateRange?.from);
    oncrossTimeFromChange(dateRange?.from);
    setcrossTimeTo(dateRange?.to);
    crossTimeToRef.current.handleChange(dateRange?.to);
    oncrossTimeToChange(dateRange?.to);
    setResetPagination(true);
    handleUpdateKey();
    setEventType(defaultSelectOption());
    setSearchText("");
    onResetInitiated();
    removeFromStorage();
  };

  return (
    <div className="reports-filter-section pb-3 position-relative">
      <div className="row mb-2">
        <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-2 px-1 px-lg-2">
          <span>Event Time From</span>
          <div className="position-relative">
            <CustomCalendar
              maxDate={maxDate}
              minDate={tab === "old" ? "" : minDate}
              dateFormat={reportDateFormat}
              timePicker
              ref={crossTimeFromRef}
              selected={crossTimeFrom === "" ? "" : new Date(crossTimeFrom)}
              onChange={(date) =>
                onFilterChange({
                  name: "cross_time_from",
                  value: date,
                  label: "",
                })
              }
              isClearable={true}
              onClear={() => handleSingleFieldReset("fromTime")}
            />
            {loading && (
              <span className="input-inline-loader-container">
                <div
                  className="spinner-border spinner-border-sm ml-5"
                  role="status"
                ></div>
              </span>
            )}
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-2 px-1 px-lg-2">
          <span>Event Time To</span>
          <div className="position-relative">
            <CustomCalendar
              maxDate={tab === "old" ? maxDate : moment().toDate()}
              minDate={crossTimeFrom ? crossTimeFrom : minDate}
              dateFormat={reportDateFormat}
              ref={crossTimeToRef}
              selected={crossTimeTo === "" ? "" : new Date(crossTimeTo)}
              onChange={(date) => {
                setMaxDate(date);
                onFilterChange({
                  name: "cross_time_to",
                  value: date,
                  label: "",
                });
              }}
              timePicker
              isClearable={true}
              onClear={() => handleSingleFieldReset("toTime")}
            />
            {loading && (
              <span className="input-inline-loader-container">
                <div
                  className="spinner-border spinner-border-sm ml-5"
                  role="status"
                ></div>
              </span>
            )}
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-2 px-1 px-lg-2">
          <span>Event Type</span>
          <Select
            className="cutomSelect"
            classNamePrefix="react-select"
            value={formatValueWithDefaultOption(eventType)}
            options={eventTypeOptions}
            onChange={(opt) =>
              onFilterChange({
                name: "type",
                value: opt?.value ?? "",
                label: opt?.label ?? "",
              })
            }
            name="type"
            placeholder="Select"
            isClearable={true}
            components={{ ClearIndicator: CustomSelectClearIndicator }}
            defaultValue={defaultSelectOption()}
          />
        </div>

        <div className="col-12 col-md-6 col-lg-4 col-xl-3 mb-2 px-1 px-lg-2">
          <span>Search</span>
          <div className="report-search-container searchHolder mb-0">
            <input
              type="text"
              className="form-control"
              name="search"
              value={searchText}
              id="search"
              placeholder="Search by Plate no. or Roadway name"
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
            />
            <ClearButton
              onClick={() => handleSingleFieldReset("search")}
              hideClear={String(searchText ?? "").length == 0}
            />
          </div>
        </div>
        <div className="row m-0 flx-end w-100 justify-content-end mt-2">
          <span className="show-lg">&nbsp;</span>
          <div className="btn-cover ">
            <button
              onClick={() => applyFilters()}
              className="btn btn-secondary rounded-0 ml-1 "
            >
              Apply
            </button>
            <button
              onClick={resetFilterOptions}
              className="btn btn-secondary reset rounded-0 ml-1 "
            >
              <i className="iconsminds-repeat-2"></i>
            </button>
            {checkModuleGeneralPermission(
              userRoleDetails,
              "anpr-event-report",
              "export_report"
            ) && (
              <div className="mr-2">
                <ExportButton
                  exportDetails={exportData}
                  disableExport={buttonVisibility}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcsReportFilter;
